import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'VatFrequency';
const ENDPOINT = `/vat-frequencies/`;

@Injectable({
    providedIn: 'root'
})
export class VatFrequencyService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
